import { registerSlot, registerSlotPreload } from "../../core/slots.jsx";
import { uses } from "../../core/uses.js";
import { ReceivedBox, receivedListQuery } from "./ReceivedBox.jsx";

/**
 * 部品 received（受け取った書類、../eigyouryoku/docs/13）を土台の差し込み口に並べる。門は core＝現場力・営業力の両方。
 *   出す／出さないの残りは使う機能 receivedDocs（枠の中で uses() を見る。OFF は画面で隠すだけ）。
 *   main.tsx が起動のときに1回呼ぶ（両製品の部品なので、製品の置き場（products/）でなくここで）
 */
export function registerReceived(): void {
  registerSlot("group.received", "core", ReceivedBox);
  // 案件の画面は、案件の詳細と受け取った書類の一覧がそろってから描く（#179：一覧が後から入ると、下の社内メモ・タブがずれる）
  registerSlotPreload("group.received", "core", (me, { groupId }, qc) => (uses(me, "receivedDocs") ? qc.ensureQueryData(receivedListQuery(groupId)) : Promise.resolve()));
}
